import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Solver from './Solver';

ReactDOM.render(<Solver />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js